$(document).ready(function () {
    const form = $('form[action="/api/contact/submit"]');

    function showFieldError(inputId, message) {
        const input = $('#' + inputId);
        input.siblings('.invalid-feedback').remove();
        input.removeClass('is-invalid');
        if (message) {
            input.addClass('is-invalid');
            input.after('<div class="invalid-feedback">' + message + '</div>');
        }
    }

    function validateFullname(value) {
        if (!value || !value.trim()) return 'Full name is required';
        if (value.trim().length < 2) return 'Full name must be at least 2 characters';
        if (value.trim().length > 150) return 'Full name must be 150 characters or less';
        if (!/^[A-Za-z][A-Za-z\s'\-\.]{1,149}$/.test(value.trim())) return 'Please enter a valid full name';
        return null;
    }

    function validateEmail(value) {
        if (!value || !value.trim()) return 'Email is required';
        if (typeof EmailHelper !== 'undefined' && !EmailHelper.isValid(value.trim())) return 'Please enter a valid email address';
        if (typeof EmailHelper === 'undefined' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) return 'Please enter a valid email address';
        return null;
    }

    function validatePhone(value) {
        if (!value || !value.trim()) return 'Phone number is required';
        const digits = value.replace(/\D/g, '');
        if (digits.length < 6 || digits.length > 15) return 'Please enter a valid phone number (6-15 digits)';
        return null;
    }

    function validateSubject(value) {
        if (!value || !value.trim()) return 'Subject is required';
        if (value.trim().length > 255) return 'Subject must be 255 characters or less';
        return null;
    }

    function validateMessage(value) {
        if (!value || !value.trim()) return 'Message is required';
        if (value.trim().length > 5000) return 'Message must be 5000 characters or less';
        return null;
    }

    const isLoggedIn = form.attr('data-logged-in') === '1';

    form.on('submit', function (e) {
        if (form.find('button[type="submit"]').prop('disabled')) {
            e.preventDefault();
            return false;
        }

        const fullname = $('#fullname').val();
        const email = $('#email').val();
        const phone = $('#phone').val();
        const subject = $('#subject').val();
        const message = $('#message').val();

        let hasError = false;

        if (!isLoggedIn) {
            const fullnameErr = validateFullname(fullname);
            showFieldError('fullname', fullnameErr);
            if (fullnameErr) hasError = true;

            const emailErr = validateEmail(email);
            showFieldError('email', emailErr);
            if (emailErr) hasError = true;

            const phoneErr = validatePhone(phone);
            showFieldError('phone', phoneErr);
            if (phoneErr) hasError = true;
        }

        const subjectErr = validateSubject(subject);
        showFieldError('subject', subjectErr);
        if (subjectErr) hasError = true;

        const messageErr = validateMessage(message);
        showFieldError('message', messageErr);
        if (messageErr) hasError = true;

        if (hasError) {
            e.preventDefault();
            if (typeof notify === 'function') {
                notify('error', 'Please correct the errors below');
            }
            $('html, body').animate({ scrollTop: form.offset().top - 100 }, 300);
            return false;
        }
    });

    $('#fullname, #email, #phone, #subject, #message').on('input change', function () {
        const id = $(this).attr('id');
        if (isLoggedIn && (id === 'fullname' || id === 'email' || id === 'phone')) return;
        const val = $(this).val();
        let err = null;
        if (id === 'fullname') err = validateFullname(val);
        else if (id === 'email') err = validateEmail(val);
        else if (id === 'phone') err = validatePhone(val);
        else if (id === 'subject') err = validateSubject(val);
        else if (id === 'message') err = validateMessage(val);
        showFieldError(id, err);
    });
});